import type { FaireProductEntity } from "../../entity_types/product";

export const default_1: FaireProductEntity = {
  token: "default-1",
  type: "product",
  name: "Ceramic Planter Pot - Terracotta",
  brandName: "Terracotta Pottery",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/55fabe0e90f2e100821208a64ed633af6e1cebb5a1bfabe932910c73a0a4ee51.webp",
  priceDollars: 18.5,
  msrpDollars: 32,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
